
var contentEl = document.querySelector('#article-content-desc');
if(contentEl){
	var contentText = contentEl.innerText || contentEl.textContent;
  var mins = Math.ceil(contentText.trim().split(/\s+/).length / 5 / 60);
  var mText = mins > 1 ? 'mins read' : 'min read';
  if(document.querySelector('#reading_time')){
    document.querySelector('#reading_time').innerHTML = mins + ' ' + mText;
  }
  
}
  